/**
 * @flow
 */
'use strict';

export const santeMedicament2Codes = [
{"code":"Abilify"},
{"code":"Accupril"},
{"code":"Accuretic"},
{"code":"Accutane"},
{"code":"Acebutolol"},
{"code":"Acetaminophene"},
{"code":"Acetioprim"},
{"code":"Acetyl cysteine"},
{"code":"Acide folique"},
{"code":"Aclasta"},
{"code":"Actemra inj"},
{"code":"Actonel"},
{"code":"Actos"},
{"code":"Adalat"},
{"code":"Adderall"},
{"code":"Advair"},
{"code":"Advil"},
{"code":"Advil cold sinus"},
{"code":"Aerius"},
{"code":"Aggrenox"},
{"code":"Aldactone"},
{"code":"Alendronate"},
{"code":"Alertec"},
{"code":"Alesse"},
{"code":"Alfuzosin"},
{"code":"Aling"},
{"code":"Allegra"},
{"code":"Allopurinol"},
{"code":"Almotech"},
{"code":"Alopurinol"},
{"code":"Alprazolam"},
{"code":"Altace"},
{"code":"Alvesco"},
{"code":"Amantatine"},
{"code":"Amarel"},
{"code":"Amerge"},
{"code":"Amiodarone"},
{"code":"Amitriptyline"},
{"code":"Amlodipine"},
{"code":"Anaprox"},
{"code":"Anastrozole"},
{"code":"Andriol"},
{"code":"Androgel"},
{"code":"Angelic"},
{"code":"Anneau gastrique"},
{"code":"Anovulant"},
{"code":"Anti-cancer"},
{"code":"Pain killer"},
{"code":"Anti-histaminique"},
{"code":"Anti-inflammatory"},
{"code":"Anti-psychotic injection"},
{"code":"Antibiotic"},
{"code":"Anticoagulant"},
{"code":"Anti depressive"},
{"code":"Apo esomeprazole"},
{"code":"Apo gliclazide"},
{"code":"Apo hydro"},
{"code":"Apo mometasone"},
{"code":"Apo omeprazole"},
{"code":"Apo oxazepam"},
{"code":"Apo pindol"},
{"code":"Apo quinapril"},
{"code":"Apo salvent"},
{"code":"Apo triazide"},
{"code":"Apo-fluconazole"},
{"code":"Apo-fosinopril"},
{"code":"Apo-ismn"},
{"code":"Apo-ticlopidine"},
{"code":"Apohydroxyzine"},
{"code":"Apometropolol"},
{"code":"Apprilum"},
{"code":"Apranax"},
{"code":"Aprilon"},
{"code":"Aredia"},
{"code":"Aricept"},
{"code":"Arimidex"},
{"code":"Arthrotec"},
{"code":"Asacol"},
{"code":"Asaphen"},
{"code":"Asatab"},
{"code":"Aspicor"},
{"code":"Aspirine"},
{"code":"Atacan"},
{"code":"Atacan generic"},
{"code":"Atacan+"},
{"code":"Atarax"},
{"code":"Atenolol"},
{"code":"Ativan"},
{"code":"Atorvastatin"},
{"code":"Atripla"},
{"code":"Atrovent"},
{"code":"Aubagio"},
{"code":"None"},
{"code":"Auro citalopram"},
{"code":"Auro quetiapine"},
{"code":"Avalide"},
{"code":"Avamys"},
{"code":"Avandia"},
{"code":"Avapro"},
{"code":"Avastatin"},
{"code":"Aventyl"},
{"code":"Avodart"},
{"code":"Avonex"},
{"code":"Axert"},
{"code":"Azathioprine"},
{"code":"Azilect"},
{"code":"Azithromycine"},
{"code":"Baclofen"},
{"code":"Benadryl"},
{"code":"Benzodiazepine"},
{"code":"Betaceron"},
{"code":"Betaderm"},
{"code":"Biaxin"},
{"code":"Bifantin"},
{"code":"Bio K"},
{"code":"Biocal"},
{"code":"Biphentin"},
{"code":"Bisoprolol"},
{"code":"Bitosa"},
{"code":"Botox"},
{"code":"Breezhaler"},
{"code":"Bricanyl"},
{"code":"Bromocriptine"},
{"code":"Buscopan"},
{"code":"Butrans"},
{"code":"C-pack"},
{"code":"Ca+/vit.D"},
{"code":"Caduet"},
{"code":"Calcia"},
{"code":"Calcite"},
{"code":"Calcitonine"},
{"code":"Calcium"},
{"code":"Caltrate"},
{"code":"Cambian"},
{"code":"Candesartan"},
{"code":"Carbamazepine"},
{"code":"Carbocal"},
{"code":"Carborite"},
{"code":"Cardizem"},
{"code":"Cardura"},
{"code":"Carvedilol"},
{"code":"Celebrex"},
{"code":"Celecoxib"},
{"code":"Celexa"},
{"code":"CellCept"},
{"code":"Centrum"},
{"code":"Certirizine"},
{"code":"Certraline"},
{"code":"Champix"},
{"code":"Chimiotherapie. "},
{"code":"Chlorothiazide"},
{"code":"Cholesterol"},
{"code":"Cholestide"},
{"code":"Cialis"},
{"code":"Cilazapril"},
{"code":"Cipralex"},
{"code":"Ciprexa"},
{"code":"Citalopram"},
{"code":"Citel"},
{"code":"Claritin"},
{"code":"Clindamycine"},
{"code":"Clobazam"},
{"code":"Clobetasol"},
{"code":"Clonazepam"},
{"code":"Clonidine"},
{"code":"Clopidrogel"},
{"code":"Clotrimaderm"},
{"code":"Clozapine"},
{"code":"Codeine"},
{"code":"Coeur"},
{"code":"Colace"},
{"code":"Colchicine"},
{"code":"Comboglyc"},
{"code":"Concentration"},
{"code":"Concerta"},
{"code":"Constella"},
{"code":"Contraceptif oral"},
{"code":"Copaxone"},
{"code":"Cordura"},
{"code":"Corgard"},
{"code":"Cortef"},
{"code":"Cortico nasal"},
{"code":"Cortisone"},
{"code":"Cositra"},
{"code":"Cotazyme"},
{"code":"Coumadin"},
{"code":"Coversyl"},
{"code":"Coversyl+"},
{"code":"Cozaar"},
{"code":"Creme cortisone"},
{"code":"Creon"},
{"code":"Crestor"},
{"code":"Crestor generic"},
{"code":"Cyclobenzaprine"},
{"code":"Cyclocapron"},
{"code":"Cyclocort"},
{"code":"Cymbalta"},
{"code":"Depro prevera. "},
{"code":"Depro provera"},
{"code":"Desirel"},
{"code":"Desonide"},
{"code":"Destrace"},
{"code":"Detrol"},
{"code":"Dexidrine"},
{"code":"Dexilant"},
{"code":"Diab.II PO"},
{"code":"Diabenil"},
{"code":"Diabeta"},
{"code":"Diamicron"},
{"code":"Diamox"},
{"code":"Diane 35"},
{"code":"Dianorm XR"},
{"code":"Dianormorm XR 500"},
{"code":"Diazepam"},
{"code":"Diazid"},
{"code":"Dicetel"},
{"code":"Dicletin"},
{"code":"Diclofenac"},
{"code":"Dilantin"},
{"code":"Dilaudid"},
{"code":"Diltiaz"},
{"code":"Diltiazem"},
{"code":"Diovan"},
{"code":"Diovan HCT"},
{"code":"Diovol"},
{"code":"Ditropan"},
{"code":"Diuretique"},
{"code":"Divalproex"},
{"code":"Diet pills"},
{"code":"Docusate sodium"},
{"code":"Domperidone"},
{"code":"Donepezil"},
{"code":"Dormir"},
{"code":"Dostinex"},
{"code":"Doxazosin"},
{"code":"Doxitab"},
{"code":"Doxycline"},
{"code":"Drixoral"},
{"code":"Duloxetine"},
{"code":"Durela"},
{"code":"Dutasteride"},
{"code":"Dydrocal"},
{"code":"Effexor"},
{"code":"Effient"},
{"code":"Elavil"},
{"code":"Eliquis"},
{"code":"Elmiron"},
{"code":"Empracet"},
{"code":"Emtec"},
{"code":"Enalapril"},
{"code":"Enbrel"},
{"code":"Entacapone"},
{"code":"Entocort"},
{"code":"Entresto"},
{"code":"Entrophen"},
{"code":"Enzyme"},
{"code":"Epipen"},
{"code":"Epival"},
{"code":"Esomeprazole"},
{"code":"Estrace"},
{"code":"Estradiol"},
{"code":"Estradot"},
{"code":"Estrogel"},
{"code":"Euro folic"},
{"code":"Euro senna"},
{"code":"Evista"},
{"code":"Exalto"},
{"code":"Exelon"},
{"code":"Exelon patch"},
{"code":"Ezetimibe"},
{"code":"Ezetrol"},
{"code":"Fampyra"},
{"code":"Femora"},
{"code":"Fenofibrate"},
{"code":"Fentanyl"},
{"code":"Fer."},
{"code":"Fibrastile"},
{"code":"Fibristal"},
{"code":"Filodopine"},
{"code":"Finasteride"},
{"code":"Fiorinal"},
{"code":"Flexiril"},
{"code":"Flomax"},
{"code":"Flonase"},
{"code":"Florinef"},
{"code":"Flovent"},
{"code":"Flovent/Ventolin"},
{"code":"Fluoxetine"},
{"code":"Fluvoxamine"},
{"code":"Folic"},
{"code":"Forxiga"},
{"code":"Fosamax"},
{"code":"Fosavance"},
{"code":"Fosinopril"},
{"code":"Frisium"},
{"code":"Frova"},
{"code":"Furosemide"},
{"code":"Gabapentin"},
{"code":"Galantamine"},
{"code":"Generique choles"},
{"code":"Genius"},
{"code":"Gilenya"},
{"code":"Gleevec"},
{"code":"Glen lamotrigen"},
{"code":"Gliclazide"},
{"code":"Glimepiride"},
{"code":"Glucobay"},
{"code":"Gluconorm"},
{"code":"Glucophage"},
{"code":"Glucosamine"},
{"code":"Glumetza"},
{"code":"Glyburide"},
{"code":"Gravol"},
{"code":"Haldol"},
{"code":"Heparine"},
{"code":"Hormones "},
{"code":"Hormonotherapie"},
{"code":"Humira"},
{"code":"Hydrasense"},
{"code":"Hydrea"},
{"code":"Hydrochlorothiazide"},
{"code":"Hydromorph contin"},
{"code":"Hydromorphone"},
{"code":"Hydroxychloroquine"},
{"code":"Hydroxyquine"},
{"code":"Hyzaar"},
{"code":"Imdur"},
{"code":"Imitrex"},
{"code":"Immodium"},
{"code":"Immuno suppresseur"},
{"code":"Imovane"},
{"code":"Imuran"},
{"code":"Imurel"},
{"code":"Incruse ellipta"},
{"code":"Indapamine"},
{"code":"Inderal"},
{"code":"Inhibace plus"},
{"code":"Injection"},
{"code":"Injection synvisc."},
{"code":"Injections cortisone"},
{"code":"Inspra"},
{"code":"Insuline"},
{"code":"Intelence"},
{"code":"Intuniv"},
{"code":"Invokana"},
{"code":"Irbesartan"},
{"code":"Jamp asa"},
{"code":"Jamp d gel"},
{"code":"Jamp dicyclomine"},
{"code":"Janumet"},
{"code":"Januvia"},
{"code":"Keppra"},
{"code":"Lacmital"},
{"code":"Lactaid"},
{"code":"Lactudad"},
{"code":"Lactulose"},
{"code":"Lamotrigine"},
{"code":"Lanoxin"},
{"code":"Lansoprazole"},
{"code":"Lantus"},
{"code":"Latuda"},
{"code":"Laxatif"},
{"code":"Lectopan"},
{"code":"Lescol"},
{"code":"Letrozol"},
{"code":"Levetiracetam"},
{"code":"Levocarb"},
{"code":"Levofloxacin"},
{"code":"Levothyrox 125"},
{"code":"Linessa"},
{"code":"Lipidil"},
{"code":"Lipidil supra"},
{"code":"Lipitor"},
{"code":"Lipitor generic"},
{"code":"Lisinopril"},
{"code":"Lithane"},
{"code":"Lithium"},
{"code":"Lodalisse"},
{"code":"Lomotine"},
{"code":"Loperamide"},
{"code":"Lopressor"},
{"code":"Loprox"},
{"code":"Lorazepam"},
{"code":"Losartan"},
{"code":"Losec"},
{"code":"Lozide"},
{"code":"Luteine"},
{"code":"Luvox"},
{"code":"Lyrica"},
{"code":"Maglucate"},
{"code":"Magnesium"},
{"code":"Marvelon"},
{"code":"Materna"},
{"code":"Mavik"},
{"code":"Maxalt"},
{"code":"Mcal"},
{"code":"Mdet"},
{"code":"Med pour coeur"},
{"code":"Med pour digestion"},
{"code":"Med pr chol"},
{"code":"Medrone"},
{"code":"Melatonine"},
{"code":"Meloxicam"},
{"code":"Meperidine"},
{"code":"Mesavant"},
{"code":"Metadol"},
{"code":"Metadone"},
{"code":"Metformin"},
{"code":"Metformin le prend +/-"},
{"code":"Methotrexate"},
{"code":"Methyl B9"},
{"code":"Methyldopazepine"},
{"code":"Methylphenidate"},
{"code":"Metonia"},
{"code":"Metoprolol"},
{"code":"Metrogel"},
{"code":"Metronidazole"},
{"code":"Micardis"},
{"code":"Micardis+"},
{"code":"Micronor"},
{"code":"Midodrine"},
{"code":"Miniestrin"},
{"code":"Minocin"},
{"code":"Minocycline"},
{"code":"Mirapex"},
{"code":"Mirena"},
{"code":"Mirtazapine"},
{"code":"Mitriptiline"},
{"code":"Modulon"},
{"code":"Mogadon"},
{"code":"Mometasone"},
{"code":"Monitan"},
{"code":"Monocor"},
{"code":"Monopril"},
{"code":"Montelukast"},
{"code":"Morphine"},
{"code":"Motilium"},
{"code":"Motrin"},
{"code":"Multivitamine"},
{"code":"Mylan bupropion"},
{"code":"Myrbetriq"},
{"code":"Mevacor"},
{"code":"Nabilone"},
{"code":"Naproxen"},
{"code":"Nasacort"},
{"code":"Nasonex"},
{"code":"Ne connait pas nom"},
{"code":"Ne prends plus"},
{"code":"Neoral"},
{"code":"Neurontin"},
{"code":"Nexium"},
{"code":"Niacine"},
{"code":"Nifedipine"},
{"code":"Nilotinib"},
{"code":"Nitro"},
{"code":"Nortryptyline"},
{"code":"Norvasc"},
{"code":"Novacor"},
{"code":"Novasen"},
{"code":"Novatech"},
{"code":"Novo 5 asa"},
{"code":"Novo clonidine"},
{"code":"Novo triamzide"},
{"code":"Novoalendronate"},
{"code":"Novofine"},
{"code":"Novoformil"},
{"code":"Novoglyburide"},
{"code":"Novohydrazide"},
{"code":"Novokana"},
{"code":"Novolin"},
{"code":"Novomix"},
{"code":"Novopranol"},
{"code":"Novorapid"},
{"code":"Novosemide"},
{"code":"Nucynta"},
{"code":"Ocuvite"},
{"code":"Oestradiol"},
{"code":"Oestrogel"},
{"code":"Olmetec"},
{"code":"Olmetec plus"},
{"code":"Omega 3"},
{"code":"Omega 3-6-9"},
{"code":"Omeprazole"},
{"code":"One-alpha"},
{"code":"Onglyza"},
{"code":"Opticrom"},
{"code":"Otrivin"},
{"code":"Oxazepam"},
{"code":"Oxeze"},
{"code":"Oxicodine"},
{"code":"Oxybutynine"},
{"code":"Oxycontin"},
{"code":"Oxygene"},
{"code":"Oxyse"},
{"code":"Oxytrol"},
{"code":"Palafer"},
{"code":"Pantoloc"},
{"code":"Pantoprazole"},
{"code":"Paracetamol"},
{"code":"Pariet"},
{"code":"Paroxetine"},
{"code":"Patch"},
{"code":"Patch nicotine"},
{"code":"Paxil"},
{"code":"Penecilline"},
{"code":"Penta B"},
{"code":"Pentasa"},
{"code":"Pepcid"},
{"code":"Phenophybrate"},
{"code":"Pillule"},
{"code":"Pindolol"},
{"code":"Pioglitazone"},
{"code":"Plaquenil"},
{"code":"Plavix"},
{"code":"Pms nabilone"},
{"code":"Pompe asthme"},
{"code":"Pompe insuline"},
{"code":"Pompe nasal"},
{"code":"Potassium"},
{"code":"Pradax"},
{"code":"Pramipexole"},
{"code":"Pravachol"},
{"code":"Pravastatin"},
{"code":"Prednisone"},
{"code":"Pregabalin"},
{"code":"Premarine"},
{"code":"Preservision"},
{"code":"Prevacid"},
{"code":"Prezista"},
{"code":"Primetropine"},
{"code":"Primidone"},
{"code":"Prinivil"},
{"code":"Pristiq"},
{"code":"Pro ASA"},
{"code":"Pro cal D"},
{"code":"Pro fluoxetine"},
{"code":"Pro ismn"},
{"code":"Pro triazide"},
{"code":"Pro-bisoprolol"},
{"code":"Probiotique"},
{"code":"Procet"},
{"code":"Prod.homeopathique pression"},
{"code":"Produits naturels"},
{"code":"Progesterone"},
{"code":"Prograf"},
{"code":"Prolia"},
{"code":"Prometrium"},
{"code":"Propanolol"},
{"code":"Propaphenol"},
{"code":"Propecia"},
{"code":"Proscar"},
{"code":"Protopic"},
{"code":"Protrin df"},
{"code":"Provastatin"},
{"code":"Provera"},
{"code":"Proxar"},
{"code":"Prozac"},
{"code":"Psoriatane"},
{"code":"Pulmicort"},
{"code":"Purinetol"},
{"code":"Questran"},
{"code":"Quetiapine"},
{"code":"Quietipine"},
{"code":"Quinapril"},
{"code":"Quinine"},
{"code":"Rabeprazole"},
{"code":"Ralixifene"},
{"code":"Ramipril"},
{"code":"Ranitidine"},
{"code":"Rapaflo"},
{"code":"Rasilez"},
{"code":"Reactine"},
{"code":"Rebif"},
{"code":"Reflux gastrique"},
{"code":"Relaxant musculaire"},
{"code":"Relpax"},
{"code":"Remeron"},
{"code":"Remicad"},
{"code":"Remzo "},
{"code":"Renedil"},
{"code":"Repaglinide"},
{"code":"Rhotral"},
{"code":"Rifampin"},
{"code":"Rilutek"},
{"code":"Risedronate"},
{"code":"Risperdal"},
{"code":"Ritalin"},
{"code":"Rivasa"},
{"code":"Rivotril"},
{"code":"Robaxacet"},
{"code":"Rosuvastatin"},
{"code":"Reactine"},
{"code":"Salbutamol"},
{"code":"Salivex"},
{"code":"Salofalk"},
{"code":"Salvent"},
{"code":"Scanne au dossier"},
{"code":"Secaris"},
{"code":"Sectral"},
{"code":"Seebri"},
{"code":"Senna"},
{"code":"Sennosides"},
{"code":"Serevent"},
{"code":"Serophen"},
{"code":"Seroquel"},
{"code":"Sertraline"},
{"code":"Sialor"},
{"code":"Silenor"},
{"code":"Simbicor"},
{"code":"Simvastatin"},
{"code":"Singulair"},
{"code":"Sinus rinse"},
{"code":"Sinusite"},
{"code":"Sinutab 1x/jour"},
{"code":"Sleep-eze"},
{"code":"Sleeping pills"},
{"code":"Spiriva"},
{"code":"Spironolactone"},
{"code":"Stalevo"},
{"code":"Stelara"},
{"code":"Sterilet"},
{"code":"Stevia"},
{"code":"Stratera"},
{"code":"Sublinox"},
{"code":"Sucrate"},
{"code":"Supeudol"},
{"code":"Iron suplement"},
{"code":"Symbicort"},
{"code":"Synthroid"},
{"code":"Tamoxifene"},
{"code":"Tamsulosin"},
{"code":"Tapazole"},
{"code":"Tecfidera"},
{"code":"Tegretol"},
{"code":"Telmisartan"},
{"code":"Tenormin"},
{"code":"Terasozin"},
{"code":"Terbinafine"},
{"code":"Teriflunamide"},
{"code":"Testosterone"},
{"code":"Tetra"},
{"code":"Tetracycline"},
{"code":"Teva clobazam"},
{"code":"Teva-pravastatin"},
{"code":"Tevavalafaxine"},
{"code":"Teveten"},
{"code":"Tiazac xc"},
{"code":"Ticlopidine"},
{"code":"Tintrellix"},
{"code":"Toctino"},
{"code":"Toloxin"},
{"code":"Topamax"},
{"code":"Topilene"},
{"code":"Topiramate"},
{"code":"Topisone"},
{"code":"Toviaz"},
{"code":"Tragenta"},
{"code":"Trajenta"},
{"code":"Tramacet"},
{"code":"Tramadol"},
{"code":"Trandate"},
{"code":"Trazodone"},
{"code":"Tridural"},
{"code":"Trileptal"},
{"code":"Trintelix"},
{"code":"Triptans"},
{"code":"Triquilar"},
{"code":"Trosec"},
{"code":"Trulicity"},
{"code":"Truvada"},
{"code":"Tudorza"},
{"code":"Twinta"},
{"code":"Tylenol"},
{"code":"Tylenol arthritis"},
{"code":"Tylenol codeine"},
{"code":"Tylenol muscular"},
{"code":"Tysabri"},
{"code":"Urso"},
{"code":"Vagifem"},
{"code":"Valacyclovir"},
{"code":"Valium"},
{"code":"Valproic acid"},
{"code":"Valsartan"},
{"code":"Valtrex"},
{"code":"Vasotec"},
{"code":"Venlafaxine"},
{"code":"Ventolin"},
{"code":"Verapamil"},
{"code":"Vesicare"},
{"code":"Vessie"},
{"code":"Viagra"},
{"code":"Victoza"},
{"code":"Videx"},
{"code":"Vimovo"},
{"code":"Vioxx"},
{"code":"Viread"},
{"code":"Vit B12"},
{"code":"Vit C"},
{"code":"Vit D"},
{"code":"Vit E"},
{"code":"Vit a et d"},
{"code":"Vit.B1"},
{"code":"Vit.D"},
{"code":"Vitalux"},
{"code":"Vitalux S"},
{"code":"Vitalux areds lutein"},
{"code":"Vitamine B6"},
{"code":"Vitamines"},
{"code":"Voir liste"},
{"code":"Voltaren"},
{"code":"Vyvanse"},
{"code":"Warfarin"},
{"code":"Wellbutrin"},
{"code":"Winpred"},
{"code":"Xanax"},
{"code":"Xarelto"},
{"code":"Xatral"},
{"code":"Xenical"},
{"code":"Yasmine"},
{"code":"Zantac"},
{"code":"Zeldox"},
{"code":"Zenhale"},
{"code":"Zestril"},
{"code":"Zezonique"},
{"code":"Zinc"},
{"code":"Zocor"},
{"code":"Zoloft"},
{"code":"Zomig"},
{"code":"Zopiclone"},
{"code":"Zyban"},
{"code":"Zyloprim"},
{"code":"Zytiga"},
]
